import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, OperatorFunction } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BankListAvailModel } from 'src/app/models/bank-list-avail.model';
import { StoreBankPayload } from 'src/app/models/bank.model';
import { ProfileService } from 'src/app/services/profile.service';
import { ModalPinComponent } from '../../../profile/components/modal-pin-verification/modal-pin-verification.component';
import { BuatPinComponent } from 'src/app/pages/dashboard/components/modal-buat-pin/buat-pin.component';

@Component({
  selector: 'app-rekening-form',
  templateUrl: './rekening-form.component.html',
  standalone: false,
})
export class RekeningFormComponent {
  @Input() bankNameList: BankListAvailModel[] = [];
  @Input() pinToken: string = '';

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<StoreBankPayload>();

  constructor(
    private modalService: NgbModal,
    private profileService: ProfileService
  ) {}

  formGroup: FormGroup = new FormGroup({
    bank: new FormControl('', [Validators.required]),
    nama: new FormControl('', [Validators.required]),
    rekening: new FormControl('', [Validators.required]),
  });

  bank: string | BankListAvailModel = '';
  rekening: string = '';
  owner: string = '';

  isEmptyBank: boolean = false;
  isEmptyRek: boolean = false;
  isEmptyOwn: boolean = false;
  isNotFound: boolean = false;

  formatter = (x: { bank_name: string } | string) => {
    if (typeof x === 'string') return x;
    return x.bank_name;
  };

  search: OperatorFunction<string, readonly BankListAvailModel[]> = (
    text$: Observable<string>
  ) =>
    text$.pipe(
      debounceTime(1000),
      map((term) =>
        term === ''
          ? []
          : this.bankNameList
              .filter(
                (v: BankListAvailModel) =>
                  v.bank_name.toLowerCase().indexOf(term.toLowerCase()) > -1
              )
              .slice(0, 10)
      )
    );

  onSearchBank(value: string | BankListAvailModel) {
    if (value && typeof value === 'object' && 'bank_name' in value) {
      this.isEmptyBank = false;
      this.isNotFound = false;
    } else {
      this.isEmptyBank = true;
    }
  }

  onAddRek(value: string) {
    this.isEmptyRek = value === '';
  }

  onAddOwner(value: string) {
    this.isEmptyOwn = value === '';
  }

  validateAdd(): void {
    let payloadBankName = '';
    let payloadBankCode = '';

    if (
      this.bank &&
      typeof this.bank === 'object' &&
      'bank_name' in this.bank
    ) {
      payloadBankName = this.bank.bank_name;
      payloadBankCode = this.bank.bank_code;
      this.isEmptyBank = false;
    } else {
      this.isEmptyBank = true;
    }

    if (!this.rekening) {
      this.isEmptyRek = true;
    }
    if (!this.owner) {
      this.isEmptyOwn = true;
    }

    if (!this.isEmptyBank && !this.isEmptyRek && !this.isEmptyOwn) {
      const profile = this.profileService.profileDataSubject.value;
      if (!profile?.pin_status) {
        this.modalService.open(BuatPinComponent, {
          backdrop: 'static',
          centered: true,
        });
        return;
      }

      const modal = this.modalService.open(ModalPinComponent, {
        backdrop: 'static',
        centered: true,
      });

      const modalInstance = modal.componentInstance as ModalPinComponent;
      modalInstance.loading.subscribe((res: any) => {
        this.pinToken = res?.pin_token || '';
        const payload: StoreBankPayload = {
          bank_name: payloadBankName,
          bank_code: payloadBankCode,
          bank_number: this.rekening,
          bank_owner: this.owner,
          pin_token: this.pinToken,
        };
        this.onSave.emit(payload);
      });
    }
  }

  reset() {
    this.formGroup.reset();
    this.bank = '';
    this.rekening = '';
    this.owner = '';
    this.pinToken = '';
    this.isEmptyBank = false;
    this.isEmptyRek = false;
    this.isEmptyOwn = false;
    this.isNotFound = false;
  }

  close() {
    this.reset();
    this.onClose.emit();
  }
}
